import { ScheduledResponse } from '../interface';

/**
 * Model class for scheduled message
 * @param {ScheduledResponse} message response to structure into scheduled message model
 */
export class ScheduledModel implements PartialBy<ScheduledResponse, 'addedBy'> {
    threadId: string;
    message: string;
    timestamp: string;
    orgMemberId: string;
    contactId: string;
    dateCreated: string;
    status: any;
    error: any;
    firstName: string;
    lastName: string;
    company: string;
    organizationId: string;
    id: string;
    name: string;
    ownerOrgMemberId: string;

    constructor(message: ScheduledResponse) {
        this.id = message.id;
        this.dateCreated = message.dateCreated;
        this.orgMemberId = message.orgMemberId;
        this.contactId = message.contactId;
        this.timestamp = message.timestamp;
        this.threadId = message.threadId;
        this.message = message.message;
        this.firstName = message.firstName;
        this.lastName = message.lastName;
        this.name = `${message.firstName} ${message.lastName}`;
        this.company = message.company;
        this.organizationId = message.organizationId;
        this.ownerOrgMemberId = message.addedBy;
        this.status = message.status;
        this.error = message.error;
    }
}
